/**
 * Centralized business / brand configuration for Inka Glass LLC.
 * All hard-coded brand details should pull from here.
 */

export const siteConfig = {
  name: "Inka Glass LLC",
  shortName: "Inka Glass",
  legalName: "Inka Glass LLC",
  owner: "Katia Leyva Avila",
  tagline: "Window & Glass Replacement in Houston, TX",
  description:
    "Trusted window and glass replacement company in Houston, TX serving homes and businesses across the greater Houston area. Window replacement and glass replacement — free estimates, fast, professional service.",

  domain: "inkaglassllc.com",
  url: "https://inkaglassllc.com",

  phone: "(346) 691-4992",
  phoneHref: "tel:+13466914992",

  email: "inkaglassinfo@gmail.com",
  emailHref: "mailto:inkaglassinfo@gmail.com",

  address: {
    street: "550 Greens Parkway Ste 204",
    city: "Houston",
    state: "TX",
    postalCode: "77067",
    region: "Harris County",
    serviceRadius: "50 miles",
  },

  hours: {
    summary: "Mon–Fri 9–5 · Sat 9–2 · Online 24/7",
    days: "Monday – Saturday",
    time: "Mon–Fri 9 AM–5 PM · Sat 9 AM–2 PM",
    note: "Online & responding to messages 24/7",
  },

  logo: "/inka-glass-logo.png",
  ogImage: "/inka-glass-logo.png",
  favicon: "/inka-glass-logo.png",

  social: {
    instagram: "https://www.instagram.com/inka.glass.co",
    facebook: null,
    tiktok: null,
    yelp: null,
  },

  discount: {
    title: "Customer Discounts",
    headline:
      "$500 referral program and 15% off for the first customers in a new area, neighborhood, or community.",
    referral: {
      label: "$500 Referral Program",
      description:
        "Refer a friend or neighbor and earn $500 when they complete their window or glass replacement project.",
    },
    firstCustomer: {
      label: "15% Off First Customers",
      description:
        "Be among the first customers in your area, neighborhood, or community and receive 15% off your project.",
    },
    cta: "Claim Your Discount",
  },

  widgets: {
    chatWidgetId: "6a33f844fb7c5e0021bc268e",
    chatLoaderSrc: "https://widgets.leadconnectorhq.com/loader.js",
    chatResourcesUrl: "https://widgets.leadconnectorhq.com/chat-widget/loader.js",

    reviewScriptSrc: "https://reputationhub.site/reputation/assets/review-widget.js",
    reviewIframeSrc:
      "https://reputationhub.site/reputation/widgets/review_widget/TNyvOLs7A8XDlEdxKIDO?widgetId=6a62674497c889c9bf677f65",

    formIframeSrc: "https://link.systemic-digital.net/widget/form/l0Xup9Zza7GkOhde8oby",
    formScriptSrc: "https://link.systemic-digital.net/js/form_embed.js",
    formId: "l0Xup9Zza7GkOhde8oby",
    formName: "Website Form",
    formHeight: 709,
  },

  serviceAreas: [
    "Houston, TX",
    "The Woodlands, TX",
    "Sugar Land, TX",
    "Pearland, TX",
    "Katy, TX",
    "Cypress, TX",
    "Spring, TX",
    "Conroe, TX",
    "Tomball, TX",
    "Humble, TX",
    "Kingwood, TX",
    "Atascocita, TX",
    "Rosenberg, TX",
    "Magnolia, TX",
  ],
} as const;

export type SiteConfig = typeof siteConfig;
